import React, { useContext, useState } from "react";
import { Link } from "gatsby";
import Icon, { IconName } from "../icon";
import AuthContext from "../../services/firebase/auth-context/provider";
import { useAnalytics } from "../../hooks/use-ga";
var MenuLink = function MenuLink(_ref) {
    var edition = _ref.edition;
    var _useState = useState(false), open = _useState[0], setOpen = _useState[1];
    var authenticated = useContext(AuthContext)[0].authenticated;
    var _useAnalytics = useAnalytics(), trackMenuOpened = _useAnalytics.trackMenuOpened;
    var toggle = function toggle() {
        setOpen(!open);
        trackMenuOpened();
    };
    return /*#__PURE__*/ React.createElement("div", {
        className: "inline-block ml-2 z-40"
    }, /*#__PURE__*/ React.createElement("button", {
        onClick: toggle
    }, /*#__PURE__*/ React.createElement(Icon, {
        iconName: IconName.MENU,
        className: "text-makroOrange w-6 lg:w-8",
        tooltip: "Men\xFC",
        color: "current-color"
    })), /*#__PURE__*/ React.createElement("div", {
        className: "menu-link-component absolute text-right text-white text-base mt-3 px-4 py-1 bg-makroBlue right-0 shadow-lg rounded-sm " + (open ? "block" : "hidden"),
        style: {
            width: "18rem"
        }
    }, /*#__PURE__*/ React.createElement(Link, {
        to: "/" + edition.slug + "/",
        className: "block my-3 hover:text-makroOrange"
    }, "Aktuelle Ausgabe"), /*#__PURE__*/ React.createElement(Link, {
        to: "/spotlight/",
        className: "block my-3 hover:text-makroOrange"
    }, "Spotlight"), /*#__PURE__*/ React.createElement(Link, {
        to: "/themenhefte/",
        className: "block my-3 hover:text-makroOrange"
    }, "Themenhefte"), /*#__PURE__*/ React.createElement(Link, {
        to: "/podcasts/",
        className: "block my-3 hover:text-makroOrange"
    }, "Podcasts"), /*#__PURE__*/ React.createElement(Link, {
        to: "/alle-artikel/",
        className: "block my-3 hover:text-makroOrange"
    }, "Archiv"), /*#__PURE__*/ React.createElement(Link, {
        to: "/ueber-uns/",
        className: "block my-3 hover:text-makroOrange"
    }, "\xDCber uns"), /*#__PURE__*/ React.createElement(Link, {
        to: "/kontakt/",
        className: "block my-3 hover:text-makroOrange"
    }, "Kontakt"), /*#__PURE__*/ React.createElement(Link, {
        to: "/abonnieren/",
        className: authenticated ? "hidden" : "block my-3 hover:text-makroOrange"
    }, "Abonnent werden")));
};
export default MenuLink;
